import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import CONFIG from './config';

export function getImgUrl(path) {
    if (!path) return '';
    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }
    if (path.startsWith('ConfigArchivos') || path.startsWith('uploads/')) {
        return `${CONFIG.API_URL}/${path}`;
    }
    if (path.startsWith('img/')) {
        return `${CONFIG.BASE_URL}${path}`;
    }
    return `${CONFIG.API_URL}/${path}`;
}

export function show_alerta(mensaje, icono, foco = '') {
    onfocus(foco);
    const MySwal = withReactContent(Swal);

    // Si es un error crítico capaz queremos que la lean bien, le damos más tiempo.
    const tiempo = icono === 'error' ? 5000 : 3000;

    MySwal.fire({
        toast: true,
        position: 'top-end',
        title: mensaje,
        icon: icono,
        showConfirmButton: false,
        timer: tiempo,
        timerProgressBar: true,
        customClass: {
            popup: 'rounded-4 shadow-sm border',
            title: 'fs-6 fw-normal'
        }
    });
}

function onfocus(foco) {
    if (foco !== '') {
        document.getElementById(foco).focus();
    }
}

/**
 * Obtiene las opciones de un tipo de calificación valorativa (Valorativa, Valorativa 1, Valorativa 2).
 * Siempre asegura que el índice 0 sea "" y las opciones sigan en orden desde el índice 1 (la menor).
 */
export function obtenerOpcionesValorativa(tipo, configuracion) {
    const isValorativa2 = (tipo === 'Valorativa 2');
    const rawVal = isValorativa2 ? configuracion?.formato_valoracion2 : configuracion?.formato_valoracion;
    const defaultOp = isValorativa2 
        ? ['', 'TED', 'TEP', 'TEA'] 
        : ['', 'SC', 'EP', 'S', 'MS', 'Sup'];
        
    if (rawVal && typeof rawVal === 'string' && rawVal.trim() !== '') {
        try {
            const jsonStr = rawVal.trim().replace(/'/g, '"');
            const parsed = JSON.parse(jsonStr);
            if (Array.isArray(parsed) && parsed.length > 0) {
                let list = [...parsed];
                if (list[0] !== '') list.unshift('');
                return list;
            }
        } catch (e) {
            let splitted = rawVal.trim().split(',').map(s => s.trim().replace(/^['"]|['"]$/g, ''));
            if (splitted.length > 0) {
                if (splitted[0] !== '') splitted.unshift('');
                return splitted;
            }
        }
    }
    return defaultOp;
}

/**
 * Determina si una calificación es la menor o reprobada (para mostrar en color rojo).
 * Para numéricas: < 6.
 * Para valorativas: si el valor coincide con el índice 1 (siendo el índice 0 = "").
 */
export function esCalificacionBaja(valor, tipoCalificacion, configuracion) {
    if (valor === null || valor === undefined || String(valor).trim() === '') return false;
    const valStr = String(valor).trim();
    
    // Si es una nota numérica
    const num = parseFloat(valStr);
    if (!isNaN(num) && /^-?\d+(\.\d+)?$/.test(valStr)) {
        return num < 6;
    }
    
    // Si es valorativa (Valorativa, Valorativa 1, Valorativa 2)
    const opcionesVal1 = obtenerOpcionesValorativa('Valorativa 1', configuracion);
    const opcionesVal2 = obtenerOpcionesValorativa('Valorativa 2', configuracion);

    if (tipoCalificacion === 'Valorativa 2') {
        const menor = opcionesVal2[1];
        return !!(menor && valStr.toLowerCase() === String(menor).trim().toLowerCase());
    } else if (tipoCalificacion === 'Valorativa' || tipoCalificacion === 'Valorativa 1') {
        const menor = opcionesVal1[1];
        return !!(menor && valStr.toLowerCase() === String(menor).trim().toLowerCase());
    }

    // Si no viene tipoCalificacion especificado, probar si coincide con el índice 1 del formato 1 o formato 2
    const menor1 = opcionesVal1[1];
    const menor2 = opcionesVal2[1];
    if ((menor1 && valStr.toLowerCase() === String(menor1).trim().toLowerCase()) ||
        (menor2 && valStr.toLowerCase() === String(menor2).trim().toLowerCase())) {
        return true;
    }

    return false;
}

/**
 * Determina si una calificación valorativa coincide con el índice 2 de la escala (para mostrar en amarillo).
 */
export function esCalificacionIndice2(valor, tipoCalificacion, configuracion) {
    if (valor === null || valor === undefined || String(valor).trim() === '') return false;
    const valStr = String(valor).trim();

    // Si es valorativa (Valorativa, Valorativa 1, Valorativa 2)
    const opcionesVal1 = obtenerOpcionesValorativa('Valorativa 1', configuracion);
    const opcionesVal2 = obtenerOpcionesValorativa('Valorativa 2', configuracion);

    if (tipoCalificacion === 'Valorativa 2') {
        const item2 = opcionesVal2[2];
        return !!(item2 && valStr.toLowerCase() === String(item2).trim().toLowerCase());
    } else if (tipoCalificacion === 'Valorativa' || tipoCalificacion === 'Valorativa 1') {
        const item2 = opcionesVal1[2];
        return !!(item2 && valStr.toLowerCase() === String(item2).trim().toLowerCase());
    }

    // Fallback si no viene tipoCalificacion especificado, probar con el índice 2 de ambos formatos
    const item2_1 = opcionesVal1[2];
    const item2_2 = opcionesVal2[2];
    if ((item2_1 && valStr.toLowerCase() === String(item2_1).trim().toLowerCase()) ||
        (item2_2 && valStr.toLowerCase() === String(item2_2).trim().toLowerCase())) {
        return true;
    }

    return false;
}

export const esCalificacionIndice3 = esCalificacionIndice2;

